export const METHOD_GET = "GET";
export const METHOD_POST = "POST";
export const METHOD_PUT = "PUT";
export const METHOD_DELETE = "DELETE";

export const STATUS_VALIDATION_ERROR = 422;
export const STATUS_OK = 200;
